import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68 } from './mg68'

export class Mg68LITE extends Mg68 {
  name: string = 'MG68_Lite'
  icon: string = list_icon
  width: number = 710
}
